<app-main-header noIcon>{{labels.pageTitle}}</app-main-header>
<div class="content">
  <app-epson-logo></app-epson-logo>
  <app-header>{{labels.pageTitle}}</app-header>
  <app-paragraph>{{labels.infos}}</app-paragraph>
</div>
